// Design Conductor renders previews onto a scene by default. Removing the `scene` query
// param yields the flat, scene-less render, which DC will not produce on its own.
export const stripSceneFromPreviewUrl = (previewUrl: string): string => {
    const normalized = previewUrl.startsWith('//') ? `https:${previewUrl}` : previewUrl;

    try {
        const url = new URL(normalized);

        url.searchParams.delete('scene');
        return url.toString();
    } catch {
        return normalized;
    }
};
